import { useCallback, useMemo } from 'react';

import { ReduxService } from 'dashboard-services/services';

export default (() => {
  const useApprovalHandlers = ({ setGroupConfig }) => {
    const onChangeApproval = useCallback((value, { name }) => setGroupConfig(config => ReduxService.updateObject(config, {
            approval: ReduxService.updateObject(config.approval, { [name]: value })
          })), [setGroupConfig]),
          onChangeApprovalAction = useCallback((value, { name }) => setGroupConfig(config => ReduxService.updateObject(config, {
            approval: ReduxService.updateObject(config.approval, {
              actions: ReduxService.updateObject(config.approval.actions, { [name]: value })
            })
          })), [setGroupConfig]),
          onChangeApprovalTemplate = useCallback((value, { name }) => setGroupConfig(config => ReduxService.updateObject(config, {
            approval: ReduxService.updateObject(config.approval, {
              templates: ReduxService.updateObject(config.approval.templates, { [name]: value })
            })
          })), [setGroupConfig]),
          onChangeReviewTTLDays = useCallback((value, { name }) => setGroupConfig(config => ReduxService.updateObject(config, {
            approval: ReduxService.updateObject(config.approval, { [name]: value })
          })), [setGroupConfig])

    return useMemo(() => ({ onChangeApproval, onChangeApprovalAction, onChangeApprovalTemplate, onChangeReviewTTLDays }), [onChangeApproval, onChangeApprovalAction, onChangeApprovalTemplate, onChangeReviewTTLDays])
  }

  return {
    useApprovalHandlers
  }
})()
